import { Button, Field, Modal } from 'coreOld/components';
import { WrapperBlock } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';
import { manufacturersService } from 'partsOld/services';
import { IManufacturer } from 'partsOld/types';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  manufacturer: IManufacturer;
  onChangeManufacturer: (value: IManufacturer) => void;
  onAssignManufacturer: (selectedItems: any, manufacturer: IManufacturer) => Promise<void>;
  filters;
  selectedItems;
}

const AssignManufacturerModalView = ({
  isOpen,
  onClose,
  manufacturer,
  onChangeManufacturer,
  onAssignManufacturer,
  filters,
  selectedItems,
}: IProps) => {
  return (
    <Modal title="Assign Manufacturer" isOpen={isOpen} onClose={onClose} size={Size.MD}>
      <WrapperBlock>
        <Field
          type={InputType.ASYNC_SELECT}
          label="Manufacturer"
          inputProps={{
            getOptions: manufacturersService.getMany,
            onChange: (e) => onChangeManufacturer(e),
            getValue: (opt) => opt,
            isClearable: false,
            size: Size.MD,
            value: manufacturer,
            placeholder: 'Select a Manufacturer',
            requestPayload: { ...filters, filtered: 1 },
          }}
        />
      </WrapperBlock>

      <WrapperBlock hideBorderBottom buttonWrapper>
        <Button onClick={() => onAssignManufacturer(selectedItems, manufacturer)}>
          Assign Manufacturer
        </Button>
      </WrapperBlock>
    </Modal>
  );
};

export default AssignManufacturerModalView;
